import { useCallback, useEffect, useState } from "react";
import { LoggedInLayoutSelector } from "../../Layouts/LoggedInLayoutSelector";
import { VerifyAdmin } from "./VerifyAdmin";
import { TutorPaymentView } from "../../firestore/Types/TutorPaymentSchema";
import { getTutorPayments, payTutorPayments } from "../../firestore/Functions/AdminFunctions";
import { Button } from "../../components/Common/Button";

type TutorPaymentBox = {
    tutor: string;
    TutorId: string;
    amount: number;
    Payments: TutorPaymentView[];
    selected: boolean;
    showMore: boolean;
}

export function UpcomingTutorPayments() {
    const [tutorPayments, setTutorPayments] = useState([] as TutorPaymentView[]);
    const [tutors, setTutors] = useState([] as TutorPaymentBox[]);

    const updateTutorPayments = useCallback(async () => {
        const payments = await getTutorPayments();
        setTutorPayments(payments.sort((a, b) => a.sessionTimeStamp.seconds - b.sessionTimeStamp.seconds));
    }, []);

    useEffect(() => {
        updateTutorPayments();
    }, [updateTutorPayments]);

    useEffect(() => {
        const tutors = [] as TutorPaymentBox[];
        for (const payment of tutorPayments) {
            const tutorIndex = tutors.findIndex(t => t.TutorId === payment.TutorId);
            if (tutorIndex === -1) {
                tutors.push({
                    tutor: payment.TutorName,
                    TutorId: payment.TutorId,
                    amount: payment.ammount,
                    Payments: [payment],
                    selected: false,
                    showMore: false
                } as TutorPaymentBox);
            } else {
                tutors[tutorIndex].Payments.push(payment);
                tutors[tutorIndex].amount += payment.ammount;
            }
        }
        setTutors(tutors);
    }, [tutorPayments]);

    const getPayTutorButtonStyle = () => {
        return tutors.some(t => t.selected) ? "primary-button" : "primary-button bg-blue-300 hover:bg-blue-300 disabled";
    }

    const handlePayTutors = async () => {
        await payTutorPayments(tutors.filter(t => t.selected).map(t => t.Payments.map(p => p.Id)).flat());
        await updateTutorPayments();
    }

    return (
        <LoggedInLayoutSelector>
            <VerifyAdmin />
            <div className="main-bg min-h-[90vh]">
                <Button className={getPayTutorButtonStyle()} disabled={!tutors.some(t => t.selected)} onClick={handlePayTutors}>pay selected tutors</Button>
                {
                    tutors.map((tutorPaymentBox, key) => (
                        <TutorPaymentBoxRow tutorPaymentBox={tutorPaymentBox} key={key} />
                    ))
                }
            </div>
        </LoggedInLayoutSelector>
    );

    function TutorPaymentBoxRow({ tutorPaymentBox }: { tutorPaymentBox: TutorPaymentBox }) {
        const handleShowMore = (e: React.MouseEvent) => {
            e.stopPropagation();
            const newTutors = tutors.map(t => {
            if (t.TutorId === tutorPaymentBox.TutorId) {
                t.showMore = !t.showMore;
            }
            return t;
            });
            setTutors(newTutors);
        }

        const handleSelectTutor = (tutor: TutorPaymentBox) => {
            const newTutors = tutors.map(t => {
                if (t.TutorId === tutor.TutorId) {
                    t.selected = !t.selected;
                }
                return t;
            });
            setTutors(newTutors);
        }

        const getSelectedstyle = () => {
            return tutorPaymentBox.selected ? "bg-blue-300 hover:bg-blue-200" : "border-gray-300 hover:bg-gray-200";
        }

        return (
            <div key={tutorPaymentBox.TutorId}>
                <div className={"flex flex-col rounded-lg border-solid border-2 m-2 p-2 w-[98%] " + getSelectedstyle()} onClick={() => handleSelectTutor(tutorPaymentBox)}>
                    <div className="flex flex-row">
                        <div className="flex flex-row w-[500px]">
                            <div className="flex flex-col m-2">
                                <div className="flex flex-row gap-2 mb-2">
                                    <div className="text-sm">Tutor Name: {tutorPaymentBox.tutor}</div>
                                </div>
                                <div className="flex flex-row gap-2 mb-2">
                                    <div className="text-sm">Total Amount: {tutorPaymentBox.amount.toFixed(2)}</div>
                                </div>
                                <div className="flex flex-row gap-2 mb-2">
                                    <div className="text-sm">TutorId: {tutorPaymentBox.Payments[0].TutorId}</div>
                                </div>
                                <div className="flex flex-row gap-2 mb-2">
                                    <div className="text-sm">Payment Tier: {tutorPaymentBox.Payments[0].TutorPaymentTier}</div>
                                </div>
                            </div>
                        </div>
                        {tutorPaymentBox.showMore ? <div className="flex flex-col grow w-[200px]">
                            <div className="flex flex-col gap-1 grow mb-4">
                                {
                                    tutorPaymentBox.Payments.map((payment, index) => (
                                        <div key={index} className="flex flex-row gap-2 rounded-lg m-2 p-2 bg-gray-100">
                                            <div className="text-sm">Session Date: {payment.sessionTimeStamp.toDate().toLocaleDateString()}</div>
                                            <div className="text-sm">Session Amount: {payment.ammount}</div>
                                            <div className="text-sm">Tutor Paid: {payment.paid}</div>
                                        </div>
                                    ))
                                }
                            </div>
                            <button className="primary-button w-20" onClick={handleShowMore}>hide</button>
                        </div>
                        : 
                        <button className="primary-button" onClick={handleShowMore}>show more</button>}
                    </div>
                </div>
            </div>
        );
    }
}